import Icon from "assets/images/detail/farm.svg"
import IconMarket from "assets/images/detail/market.svg"
import classNames from "classnames"
import moment from "jalali-moment"
import { useLocation } from "react-router-dom"
interface IDistinguishedProps {
    date : string | undefined
}
export default function Distinguished({date} : IDistinguishedProps) {
    const {pathname} = useLocation()
    const isFarm = pathname.includes("farm")
  return (
    <div className=" my-6 border border-solid border-distinguished-detail bg-distinguished-detail-bg mx-2 p-4 rounded-md" >
        <div className="flex" >
            <img src = {isFarm ?  Icon : IconMarket} alt = "distinguished" className=" -mt-1 ml-1" />
            <p className={classNames(isFarm ? " text-blue-1" : " text-green-grade")}>تایید اطلاعات کشت مزرعه</p>
        </div>
        <p className=" text-gray-6 mt-2">محصول و مقدار کشت، مورد تایید سامانه مزرعه است.</p>
        <div className="flex justify-between text-sm mt-3" >
            <p className=" text-gray-6" >تاریخ شروع برداشت محصول:</p>
            <p className=" text-gray-6" >{date && moment(date).locale("fa").format("YYYY/MM/DD")}</p>
        </div>
    </div>
  )
}
